/*
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-26 16:01:23
 * @LastEditors: lc
 * @LastEditTime: 2025-03-05 09:33:50
 */
/**
  * 充值卡 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/jinfeixibi/';

const studylevel = {
    // 列表
    list (params) {
        return axios.get(api + 'studylevel/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'studylevel/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'studylevel/detail', { params: params })
    },
    edit (params) {
        return axios.post(api + 'studylevel/edit', qs.stringify(params))
    },
    // 修改状态
    status (params) {
        return axios.post(api + 'studylevel/status', qs.stringify(params))
    },
    sort (params) {
        return axios.post(api + 'studylevel/sort', qs.stringify(params))
    },
    remove (params) {
        return axios.post(api + 'studylevel/remove', qs.stringify(params))
    },
}


// 导出接口
export default studylevel